import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { general as CommonApi } from "@teem/constants/api";

@Injectable({
	providedIn: 'root'
})
export class TeemappService {
	constructor(
		private httpClient: HttpClient
	) { }

	getPlans() {
		return this.httpClient.get(CommonApi.plans);
	}

	verifyPromocode(params: any) {
		return this.httpClient.post(CommonApi.verify_promocode, params);
	}

	verifyCrFreelance(params: any) {
		return this.httpClient.post(CommonApi.verify_cr_freelance, params);
	}

	changePlan(params: any) {
		return this.httpClient.post(CommonApi.change_plan, params);
	}

	addCard(params: any) {
		return this.httpClient.post(CommonApi.add_card, params);
	}

	sendNotifyMail(email: string) {
		return this.httpClient.get(`${CommonApi.send_notify}?email=${email}`);
	}

	startFreeTrialPlan(params: any) {
		return this.httpClient.post(CommonApi.trial_plan, params);
	}
}